document.addEventListener('DOMContentLoaded', () => {
  const placeholders = document.querySelectorAll(
    '.article-product-embed[data-product-handle]'
  );

  placeholders.forEach(async (placeholder) => {
    const handle = placeholder.dataset.productHandle;

    if (!handle) return;

    try {
      const url =
        `${window.Shopify.routes.root}products/${encodeURIComponent(handle)}` +
        `?section_id=article-product-embed`;

      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`Could not load product: ${handle}`);
      }

      const html = await response.text();

      const template = document.createElement('template');
      template.innerHTML = html.trim();

      const productCard = template.content.querySelector(
        '.article-product-card'
      );

      if (!productCard) return;

      placeholder.replaceWith(productCard);

    } catch (error) {
      console.error('Article product embed error:', error);
    }
  });
});